import React from "react";
import { t } from "i18next";
import { HeadingText, SubHeadingText } from "components/TextTranslationContainer";

// TODO: requires cleanup, remove Basket Header if not using

export const BasketInfo = ({title, subTitle}) => {
  return (
    <div className="">
       <HeadingText text={title} />
        <SubHeadingText text={subTitle} />
    </div>
  );
}


function BasketHeader() {
  return (
    <div className="flex justify-between border-b-2 border-black-100 px-4 w-full relative">
      <div className="mx-2 py-5 absolute">
        <button type="button" className="">
          <span className="rounded-full flex items-center justify-center bg-circle p-2 hover:border border-red-500 cursor-pointer">
            <svg viewBox="0 0 24 24" className="h-4 w-4 transform rotate-90">
              <path
                fill="#abadad"
                d="M4.88398 7.11612L3.11621 8.88389L12.0001 17.7678L20.884 8.88389L19.1162 7.11612L12.0001 14.2322L4.88398 7.11612Z"
              ></path>
            </svg>
          </span>
        </button>
      </div>
      <div className="my-0 mx-auto py-5 text-22x font-bold text-outer-space leading-28x w-full text-center">
        {t("Your Basket")}
      </div>
    </div>
  );
}

export default BasketHeader;
